<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  requiredIf
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 
import Loader from "@/components/widgets/loader.vue";
import createChurn from "./create_churn.vue";

export default {
    page: {
    title: "AltYapı Sorgula",
    meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
      Layout,
      PageHeader,
      Loader,
      createChurn
    },
    validations: {
       infras: {
            bbk: {
                required: requiredIf(function () {
                    return this.form.type == 'bbk'
                })
            },
        },
        form: {
            pstn: {  
                required: requiredIf(function () {
                    return this.form.type == 'pstn'
                }) 
            },
        },
    },
    data(){
        return {
            load:true,
            title: "ALTYAPI SORGULA",
            items: [
                {
                  text: "ANASAYFA",
                  href: "/",
                },
                {
                  text: "ALTYAPI SORGULA",
                  active: true,
                },
            ],
            sorguSonucu: false,
            list:{},
            isChurn:false,
            form:{ type:'bbk'},
            infras:{},
            data:{},
            loading:false,
            submitted: false,
            ilList : [],
            ilceList : [],
            bucakList : [],
            koyList : [],
            mahalleList : [],
            sokakList : [],
            binaList : [],
            daireList : [],
        }
    },
    mounted(){
       this.setSelected({ id : 0},'il');
    },
    methods:{
      formSubmit(){
        this.submitted = true;
        this.sorguSonucu = false;
        this.$v.$touch();
        if (this.$v.$invalid) return;
        this.infrastructure({ ...this.infras, type:this.form.type })
        this.submitted = false;
      },
      infrastructure(params){
        this.loading = true
        this.$http.post('/vae/infrastructure' , params)
        .then(resp => {
          this.data = {}
          if(resp.data.error) return notify.error(resp.data.message)
          this.data = resp.data.content
        })
        .catch(error => error)
        .finally(()=> {
            this.sorguSonucu = true;
            this.loading = false
          })
      },
      allClear(){
        this.form = {type:'bbk'}
        this.data = {}
      },
      createApplication(){
        this.list = { ...this.data, isChurn:this.isChurn }
    
        this.$parent.$bvModal.show('modal-scoped')
      },
      async setSelected(val,event = null){
        
          const object = event + 'List' 
          const { id } = val
          let response = null

          if(event == 'adresGetir'){
            this.infrastructure({ bbk:id, type:'bbk' })
            return
          }

          response = await this.$http.get(`/vae/adressQuery/${event}/${id}`)
          .catch(error => {
              // eslint-disable-next-line no-console
              console.log(error)
          })
          this[object] = response.data;
      },
    },
}
</script>
<template>
 <Layout>
  <PageHeader :title="title" :items="items" />
  <create-churn :list="list"/>
  <div class="row">
    <div class="col-lg-6">
      <Loader :loading="true" :load="loading">
      <div class="card">
          <div class="card-body">
            <form class="needs-validation" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-xl-4">
                  <div class="mb-3">
                      <label >Sorgu Türü</label>
                      <select 
                        class="form-control form-select" 
                        v-model="form.type"
                      >
                        <option value="bbk">BBK</option>
                        <option value="pstn">PSTN</option>
                        <option value="adres">Adres Seçerek</option>
                    </select>
                  </div>
                </div>
                <div class="col-xl-8" v-if="form.type=='pstn'">
                  <div class="mb-3">
                      <label>PSTN NO:</label>
                      <input 
                          type="text" 
                          v-model="form.pstn" 
                          class="form-control"
                          :class="{
                                'is-invalid': submitted && $v.form.pstn.$error,
                              }"
                      /> 
                      <div
                        v-if="submitted && !$v.form.pstn.required"
                        class="invalid-feedback"
                      >
                      Bu alanı doldurmak zorunludur.
                      </div>
                  </div>
                </div>
                <div class="col-xl-8" v-if="form.type=='bbk'">
                  <div class="mb-3">
                      <label>BBK NO:</label>
                      <input 
                        type="text"
                        v-model="infras.bbk" 
                        class="form-control"  
                        :class="{
                            'is-invalid': submitted && $v.infras.bbk.$error,
                          }"
                        /> 
                      <div
                          v-if="submitted && !$v.infras.bbk.required"
                          class="invalid-feedback"
                        >
                        Bu alanı doldurmak zorunludur.
                        </div>
                  </div>
                </div>
                <div class="col-xl-8" v-if="form.type=='adres'">
                  <div class="row mb-3">
                     <div>
                      <label>Adres Sorgulama</label>
                      <v-select
                          label="name" 
                          v-model="form.province"
                          :options="ilList" 
                          :reduce="country => country.name"
                          placeholder="İl"
                          @option:selecting="setSelected($event,'ilce')"><span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                    <div
                      v-if="submitted && $v.form.province.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.province.required"
                        >Bu alanı doldurmak zorunludur.</span
                      >
                    </div>
                  </div>
                  <div class="row mb-3">
                     <div>
                      <v-select 
                          v-model="form.district"
                          label="name" 
                          :options="ilceList" 
                          :reduce="country => country.name"
                           placeholder="İlçe"
                          @option:selecting="setSelected($event,'bucak')"><span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                    <div
                      v-if="submitted && $v.form.district.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.district.required"
                        >Bu alanı doldurmak zorunludur.</span
                      >
                    </div>
                  </div>
                  <div class="row mb-3">
                     <div>
                      <v-select 
                        label="name"  
                        v-model="form.township"                     
                        :options="bucakList" 
                        :reduce="country => country.name"
                        placeholder="Bucak"
                        @option:selecting="setSelected($event,'koy')"><span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                    <div
                      v-if="submitted && $v.form.district.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.district.required"
                        >Bu alanı doldurmak zorunludur.</span
                      >
                    </div>
                  </div>
                  <div class="row mb-3">
                     <div>
                       <v-select 
                          label="name" 
                          v-model="form.village"
                          :options="koyList" 
                          :reduce="country => country.name"
                          placeholder="Köy"
                          @option:selecting="setSelected($event,'mahalle')"><span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                    <div
                      v-if="submitted && $v.form.district.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.district.required"
                        >Bu alanı doldurmak zorunludur.</span
                      >
                    </div>
                  </div>
                  <div class="row mb-3">
                     <div>
                      <v-select 
                          label="name" 
                          v-model="form.neighbourhood"
                          :options="mahalleList" 
                          :reduce="country => country.name"
                          placeholder="Mahalle"
                          @option:selecting="setSelected($event,'sokak')"><span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                    <div
                      v-if="submitted && $v.form.district.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.district.required"
                        >Bu alanı doldurmak zorunludur.</span
                      >
                    </div>
                  </div>
                  <div class="row mb-3">
                     <div>
                     <v-select 
                        label="name" 
                        v-model="form.street"
                        :options="sokakList" 
                        :reduce="country => country.name"
                        placeholder="Sokak"
                        @option:selecting="setSelected($event,'bina')"><span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                    <div
                      v-if="submitted && $v.form.district.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.district.required"
                        >Bu alanı doldurmak zorunludur.</span
                      >
                    </div>
                  </div>
                  <div class="row mb-3">
                     <div>
                     <v-select 
                        taggable
                        label="name" 
                        v-model="form.buildnum"
                        :options="binaList" 
                        :reduce="country => country.name"
                         placeholder="Apartman"
                        @option:selecting="setSelected($event,'daire','binaList')"><span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                    <div
                      v-if="submitted && $v.form.district.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.district.required"
                        >Bu alanı doldurmak zorunludur.</span
                      >
                    </div>
                  </div>
                  <div class="row mb-3">
                     <div>
                       <v-select
                        label="name" 
                        taggable
                        v-model="form.floornum"
                        :options="daireList" 
                        :reduce="country => country.name"
                        placeholder="Kapı No"
                        @option:selecting="setSelected($event,'adresGetir','daireList')"
                       ><span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                    <div
                      v-if="submitted && $v.form.district.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.district.required"
                        >Bu alanı doldurmak zorunludur.</span
                      >
                    </div>
                  </div>
                </div>
            </div>
              <div class="row">
                <div class="col-md-12 text-end">
                  <div class="button-items">
                      <button 
                        type="button"
                        class="btn btn-outline-danger"  
                        @click="allClear()" 
                        >
                        Sorguyu Temizle
                      </button>
                      <button 
                        type="submit"
                        class="btn btn-primary"   
                        >
                          Sorgula
                      </button>
                  </div>
                </div>
              </div>    
            </form>
            <!-- end card -->
        </div>
      </div>
      </Loader>
    </div>
    <div class="col-md-6" v-if="sorguSonucu">
        <div class="card">
          <div class="card-body">
              <table class="table table-sm">
                  <tbody>
                      <tr>
                          <td>Alabileceği Max. Hız</td>
                          <th class="text-end">{{  this.data.hiz  }}</th>
                      </tr>
                      <tr>
                          <td>Hizmet Türü</td>
                          <th class="text-end">{{  this.data.hizmetturu  }}</th>
                      </tr>
                        <tr>
                          <td>Port Durumu</td>
                          <th class="text-end">{{  this.data.port  }}</th>
                      </tr>
                      <tr>
                          <td>Santral Adı</td>
                          <th class="text-end">{{  this.data.santraladi  }}</th>
                      </tr>
                      <tr>
                          <td>Açık Adres</td>
                          <th class="text-end">{{  this.data.acikadres  }} </th>
                      </tr>
                  </tbody>
              </table>
          </div>
          <footer class="card-footer">
            <div class="d-flex justify-content-between" v-if="this.data.port == 'Var'">
              <button class="btn btn-success btn-sm"  @click.prevent="isChurn=false;createApplication()">Başvuru Al</button>
              <button class="btn btn-primary btn-sm" @click.prevent="isChurn=true;createApplication()">Churn Girişi</button>
            </div>
            <div v-else>
              <h5> Port Bulunmamaktadır</h5>
            </div>
          </footer>
        </div>
    </div>
  </div>
  <!-- end row -->
</Layout>
</template>